import { render, staticRenderFns } from "./ScreenComision.vue?vue&type=template&id=4ff1545f"
import script from "./ScreenComision.vue?vue&type=script&lang=js"
export * from "./ScreenComision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports